"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAttributeFiltersHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var redux_batched_actions_1 = require("redux-batched-actions");
var difference_1 = tslib_1.__importDefault(require("lodash/difference"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
var general_1 = require("../../../events/general");
var filters_1 = require("../../../events/filters");
var filterContext_1 = require("../../../store/filterContext");
var filterContextSelectors_1 = require("../../../store/filterContext/filterContextSelectors");
var common_1 = require("../common");
var eventDispatcher_1 = require("../../../store/_infra/eventDispatcher");
var layout_1 = require("../../../store/layout");
function removeAttributeFiltersHandler(ctx, cmd) {
    var filterLocalIds, allFilters, _a, removedFilters, survivingFilters, invalidLocalIds, _loop_1, removedFilters_1, removedFilters_1_1, removedFilter, e_1_1;
    var e_1, _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                filterLocalIds = cmd.payload.filterLocalIds;
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilters)];
            case 1:
                allFilters = _c.sent();
                _a = tslib_1.__read(partition_1.default(allFilters, function (item) {
                    return filterLocalIds.includes(item.attributeFilter.localIdentifier);
                }), 2), removedFilters = _a[0], survivingFilters = _a[1];
                invalidLocalIds = difference_1.default(filterLocalIds, allFilters.map(function (filter) { return filter.attributeFilter.localIdentifier; }));
                if (invalidLocalIds.length) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Invalid filterLocalIds provided. These ids were not found: " + invalidLocalIds.join(", ") + ".");
                }
                _loop_1 = function (removedFilter) {
                    var affectedChildren, batch;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                affectedChildren = survivingFilters.filter(function (item) { var _a; return (_a = item.attributeFilter.filterElementsBy) === null || _a === void 0 ? void 0 : _a.some(function (parent) {
                                    return filterLocalIds.includes(parent.filterLocalIdentifier);
                                }); });
                                batch = redux_batched_actions_1.batchActions(tslib_1.__spread(affectedChildren.map(function (_a) {
                                    var attributeFilter = _a.attributeFilter;
                                    return filterContext_1.filterContextActions.setAttributeFilterParents({
                                        filterLocalId: attributeFilter.localIdentifier,
                                        parentFilters: attributeFilter.filterElementsBy.filter(function (parent) {
                                            return parent.filterLocalIdentifier !== (removedFilter === null || removedFilter === void 0 ? void 0 : removedFilter.attributeFilter.localIdentifier);
                                        }),
                                    });
                                }), [
                                    // remove filter itself
                                    filterContext_1.filterContextActions.removeAttributeFilter({
                                        filterLocalId: removedFilter.attributeFilter.localIdentifier,
                                    }),
                                    // remove filter's display form metadata object
                                    filterContext_1.filterContextActions.removeAttributeFilterDisplayForms(removedFilter.attributeFilter.displayForm),
                                    // house-keeping: ensure the removed attribute filter disappears from widget ignore lists
                                    layout_1.layoutActions.removeIgnoredAttributeFilter({
                                        displayFormRefs: [removedFilter.attributeFilter.displayForm],
                                    }),
                                ]));
                                return [4 /*yield*/, effects_1.put(batch)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.attributeFilterRemoved(ctx, removedFilter, affectedChildren, cmd.correlationId))];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _c.label = 2;
            case 2:
                _c.trys.push([2, 7, 8, 9]);
                removedFilters_1 = tslib_1.__values(removedFilters), removedFilters_1_1 = removedFilters_1.next();
                _c.label = 3;
            case 3:
                if (!!removedFilters_1_1.done) return [3 /*break*/, 6];
                removedFilter = removedFilters_1_1.value;
                return [5 /*yield**/, _loop_1(removedFilter)];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5:
                removedFilters_1_1 = removedFilters_1.next();
                return [3 /*break*/, 3];
            case 6: return [3 /*break*/, 9];
            case 7:
                e_1_1 = _c.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 9];
            case 8:
                try {
                    if (removedFilters_1_1 && !removedFilters_1_1.done && (_b = removedFilters_1.return)) _b.call(removedFilters_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 9: return [4 /*yield*/, effects_1.call(common_1.dispatchFilterContextChanged, ctx, cmd)];
            case 10:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
exports.removeAttributeFiltersHandler = removeAttributeFiltersHandler;
//# sourceMappingURL=removeAttributeFiltersHandler.js.map